module.exports = __webpack_public_path__ + "a67ddf16c69cf9f5ce64bd4815efaf54.svg";